import { UseCaseListResponseV1 } from "@ucchub/ui/src/apiTypes/organisation";
import environment from "environment";
import { BaseService } from "@services/BaseService";
import { UseCase } from "@components/CommercialCriteria/UseCase.types";
import { useState } from "react";
import { t } from "i18next";
import toArrayQueryString from "@utils/queryStringWithArray";
import { UseCaseListRequestV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers/UseCaseListRequestV1";

const useUseCase = () => {
  const [useCaseList, setUseCaseList] = useState<UseCase[]>([]);
  const [useCaseListError, setUseCaseListError] = useState<string>();
  const [isUseCaseLoading, setIsUseCaseLoading] = useState(false);

  const fetchUseCaseList = (payload: UseCaseListRequestV1) => {
    setIsUseCaseLoading(true);
    setUseCaseListError("");
    const queryString = toArrayQueryString(payload);
    const apiUrl = environment.api.useCase + "?" + queryString;
    BaseService.get<UseCaseListResponseV1[]>(apiUrl)
      .then(({ data }) => {
        setUseCaseList(data);
      })
      .catch(() => {
        setUseCaseListError(
          t("core:customers:fetch_failure_use_case") || undefined
        );
      })
      .finally(() => {
        setIsUseCaseLoading(false);
      });
  };

  return {
    useCaseList,
    useCaseListError,
    isUseCaseLoading,
    fetchUseCaseList,
  };
};

export default useUseCase;
